import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
import NewEvent from './components/NewEvent'
import Events from './components/Events'
import Event from './components/Event'
import EventView from './components/EventView'
import Home from './components/Home'
import Signup from './components/Signup'
import Signin from './components/Signin'
import Participant from './components/Participant'
import DrawLot from './components/DrawLot'

Vue.use(Router)

let router = new Router({
    mode: 'history',
    routes: [
        { path: '/', component: Home},
        { path: '/signup', component: Signup},
        { path: '/signin', component: Signin},
        { path: '/newevent', component: NewEvent, meta: { requiresAuth: true }},
        { path: '/events', component: Events, meta: { requiresAuth: true }},
        { path: '/event/:id', name: 'event', component: Event, meta: { requiresAuth: true }},
        { path: '/event/:id/drawlot', name: 'drawlot', component: DrawLot, meta: { requiresAuth: true }},
        { path: '/eventview/:userId/:eventId', name: 'eventview', component: EventView},
        { path: '/eventview/:userId/:eventId/:participantId', name: 'participant', component: Participant}
    ]
})

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    if (requiresAuth) {
        // このルートはログインされているかどうか認証が必要です。
        // もしされていないならば、ログインページにリダイレクトします。
        firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
                next()
            } else {
                next({
                    path: '/signin',
                    query: { redirect: to.fullPath }
                })
            }
        })
    } else {
        next() // next() を常に呼び出すようにしてください!
    }
})

export default router